import { createSelector } from 'reselect'
import getUnlockedExtraFreeSamplesTierCartSelect from 'modules/cart/redux/selectors/get-unlocked-extra-free-samples-tier'
import hasUnlockedExtraFreeSamplesCartSelectUtil from 'modules/cart/redux/selectors/has-unlocked-extra-free-samples/utils'

const hasUnlockedExtraFreeSamplesCartSelect = createSelector(
  getUnlockedExtraFreeSamplesTierCartSelect,
  (
    unlockedExtraFreeSamplesTier
  ) => {
    return hasUnlockedExtraFreeSamplesCartSelectUtil({
      unlockedExtraFreeSamplesTier
    })
  }
)

export default hasUnlockedExtraFreeSamplesCartSelect
